<template>
  <div class="job-page">
    <div
      v-loading="loading"
      class="container"
      style="background: transparent"
    >
      <iframe
        ref="form"
        :onload="onLoad(this)"
        :height="height"
        :src="`https://boards.greenhouse.io/embed/job_app?for=luminary&token=${$route.params.jobId}`"
        class="application-form"
        scrolling="no"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
        width="100%"
      />
    </div>
  </div>
</template>

<script>
import Job from '../../services/Job';

export default {
  name: 'Job',
  data() {
    return {
      job: null,
      jobsProvider: new Job(),
      loading: true,
      application: {},
      height: 400,
    };
  },
  mounted() {
    const { jobId } = this.$route.params;
    if (jobId) {
      // this.getJobDetail(jobId)
    } else {
      this.loading = false;
    }
  },
  methods: {
    getJobDetail(jobId) {
      this.jobsProvider.getJobDetail(jobId).then((resp) => {
        const job = resp;
        job.content = this.htmlDecode(job.content);
        this.job = job;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    htmlDecode(input) {
      const e = document.createElement('div');
      e.innerHTML = input;
      // handle case of empty input
      return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
    },
    onLoad() {
      const ctx = this;
      window.addEventListener('message', (event) => {
        ctx.loading = false;
        ctx.height = (!Number.isNaN(event.data) && event.data) > ctx.height ? (event.data + 100) : ctx.height;
      }, false);
    },
  },
};
</script>

<style lang="scss">
.job-page {
  .job-header {
    .title {
      margin: 10px 0;
    }

    .el-button {
      font-size: 18px;
      width: 100%;
      border-radius: 16px;
      padding: 15px;
      max-width: 180px;
    }
  }
}

@media (max-width: 768px) {
  .job-page {
    .job-header {
      .company {
        margin-top: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/careers/JobDetail.vue